import { lazy } from 'react';

export const LogoAndroidDownLoad = lazy(
	() => import(/* webpackChunkName: "logo-android-download" */ './logo-android-download.js')
);
export const LogoAppleDownLoad = lazy(
	() => import(/* webpackChunkName: "logo-apple-download" */ './logo-apple-download.js')
);
export const LogoDGA = lazy(() => import(/* webpackChunkName: "logo-dga" */ './logo-dga.js'));
export const LogoGGA = lazy(() => import(/* webpackChunkName: "logo-gga" */ './logo-gga.js'));
export const LogoMGA = lazy(() => import(/* webpackChunkName: "logo-mga" */ './logo-mga.js'));
export const LogoSpelinspektionen = lazy(
	() => import(/* webpackChunkName: "logo-sga-spelinspektionen" */ './logo-spelinspektionen.js')
);
export const LogoWeSpin = lazy(() => import(/* webpackChunkName: "logo-wespin" */ './logo-we-spin.js'));
export const LogoMitID = lazy(() => import(/* webpackChunkName: "logo-mitid" */ './logo-mitid.js'));
export const LogoKSA = lazy(() => import(/* webpackChunkName: "logo-ksa" */ './logo-ksa.tsx'));
